// src/components/CustomerSummary/components/UrgentEmergentNotificationsTable.jsx
// ============================================================================
// BLOCK CS.UI.UEN.0 — UrgentEmergentNotificationsTable (read-only + resizable)
// ----------------------------------------------------------------------------
// INPUT FORMAT (tab-delimited; 2 columns)
// - One row per line: <label>\t<value>
// ============================================================================

import React from 'react';

import ResizableTextTable from './ResizableTextTable.jsx';
import { TABLE_FORMATS } from './tableFormats.js';

export default function UrgentEmergentNotificationsTable({
  text,
  columnWidths,
  onColumnWidthsChange,
}) {
  return (
    <ResizableTextTable
      text={text}
      columnWidths={columnWidths}
      onColumnWidthsChange={onColumnWidthsChange}
      format={TABLE_FORMATS.urgentEmergentNotifications}
    />
  );
}
